import {Component, OnInit, Input, ElementRef, ViewChild, Output, EventEmitter} from '@angular/core';
import {DocumentsService} from '../../../../services/document.service';
import $ from 'jquery';
@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss']
})
export class DocumentViewerComponent implements OnInit {
  @ViewChild('document_container') private document_viewer: ElementRef;
  @Input() active: Boolean;
  @Output() closed  = new EventEmitter<Boolean>();
  timer;


  constructor(public document_service: DocumentsService, private _elementRef: ElementRef) {
    document_service.selected_page_broadcaster.subscribe(selected_page => this.gotoPage(null, selected_page));
  }

  ngOnInit() {
  }


  scrollViewerTo(offset) {
    this.document_viewer.nativeElement.scrollTop = offset;
  }

  gotoPage(event, page, delay= 0) {
    this.document_service.selected_page = +page;
    let result = this._elementRef.nativeElement.querySelector('.document_viewer #page_' + page);
    if (result) {
      setTimeout(() => {
        console.log(result.offsetTop);
        this.scrollViewerTo(result.offsetTop);
      }, delay)
    }
  }
  page_in_view(page_index) {
    if (this.active) {
    this.document_service.selected_page = page_index;
    }
  }

  trigger_preview_closed() {
    this.document_service.is_pchf = false;
    this.closed.emit(true);
  }

  page_scrolling(event, page_number?) {
    clearTimeout(this.timer);
    this.timer = setTimeout( () => {
      let page_in_view = $('.document_viewer .page').filter(function(i, e) {
        let difference = $(e).position().top - $('.document_viewer').scrollTop();
        return difference >= -500 && difference <= 500
      });
      if (page_in_view.length > 0 ) {
        let page_number = parseInt($(page_in_view[0]).attr('page_number') );
        this.page_in_view(page_number);
      }

    } , 150 );
  }

}
